/* eslint-disable complexity */
/* eslint-disable camelcase */
import {ubcSendH5 as send} from '@baidu/med-utils/lib/ubcV2/ubc.h5';
import {EVENT_NAME, EVENT_TYPE_VIEW} from '@/dicts/ubcConfig';
import {getUrlParamValue} from '../utils';
/**
 * 发送曝光日志
 * @param element DOM节点
 * ubc打点中page、type、value均为必传参数, 请按要求传参
 */
interface Conf {
    page?: string;
    value?: string;
    sfRef?: string;
    pageSourceId?: string;
    pageType?: string;
    valueId?: string | undefined;
    valueTitle?: string;
    valueType?: string;
}
export function sendExposureLog(element: HTMLElement) {
    let conf: Conf = {};
    const showInfo = element.dataset
        ? (element.dataset.show)
        : (element.getAttribute('data-show'));


    if (showInfo) {
        try {
            conf = JSON.parse(showInfo);
            send({
                type: EVENT_TYPE_VIEW,
                value: conf.value ?? '',
                page: conf.page ?? '',
                // eslint-disable-next-line camelcase
                page_source_key: 'id',
                ext: {
                    sf_ref: getUrlParamValue(window.location.href, 'sf_ref'),
                    sf_ch: getUrlParamValue(window.location.href, 'sf_ch'),
                    page_source_id: conf.pageSourceId,
                    page_type: conf.pageType ?? '',
                    value_id: conf.valueId,
                    value_title: conf.valueTitle ?? '',
                    value_type: conf.valueType ?? '',
                    in_ref_from: getUrlParamValue(window.location.href, 'from'),
                    referrer: window && window.document && window.document.referrer,
                },
            }, EVENT_NAME);
        } catch (error) {
            console.error(error);
        }
    }
}
